import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { componentKey, setClickedFormDetails, setDeleteRejectedFormModal, setPaginationState, setSelectedForm, setSelectedPayer, setSelectedRejected1099Forms, setSelectedTaxYear, setPayerDropdownPagination } from "./Form1099Slice";
import SelectDropdown from "../../../../components/dropdown/selectdropdown/SelectDropdown";
import Label from "../../../../components/label/Label";
import { LABEL_WEIGHT } from "../../../../components/label/constants";
import commonStyles from "../../FormSection.styles";
import RichGrid from "../../../../components/richgrid/RichGrid";
import { ROW_SELECTION_OPTIONS } from "../../../../components/richgrid/constants";
import Button from "../../../../components/button/Button";
import Loadable from "../../../../components/loadable/Loadable";
import useGarbageCollector from "../../../../../libs/garbagecollector/garbageCollectorHooks";
import { EDIT_FORM_ORIGIN, FORM_SECTION_ROUTES, QUERY_PARAMS } from "../../constants";
import { deleteRejectedForm, getFormsList, getPayersBySelectedForm, getRejectedFormsGridData, getTaxYears, resubmitRejectedForm, viewRejectedFormPDF } from "./Form1099Saga";
import { BUTTON_TYPE } from "../../../../components/button/constants";
import Payer from "../../../../../libs/utility/Payer";
import { addNotifications } from "../../../toaster/ToasterPortalSlice";
import ConfirmationPopup from "../../../../components/popup/confirmationpopup/ConfirmationPopup";
import { VEC_ICON_NAME } from "../../../../components/icons/constants";
import Icons from '../../../../components/icons/Icons';
import { COMMON_LOADING_STATES, COMMON_LOADING_STATES_MESSAGE_MAP } from "../../../constants/constants";
import { REVIEW_REJECTED_LOADING_STATES, REVIEW_REJECTED_STATES_MESSAGE_MAP } from "../constants";
import useTxSearchParams from "../../../../../libs/txsearchparams/TxSearchParamsHook";
import useTxNavigate from "../../../../../libs/txnavigate/TxNavigateHook";
import General from "../../../../../libs/utility/General";
import useFormatTIN from "../../../../../libs/customhooks/useFormatTIN";

function Form1099() {

    useGarbageCollector(componentKey);
    const dispatch = useDispatch();
    const [queryParams, setQueryParams] = useTxSearchParams();
    const navigate = useTxNavigate();
    const { formatTIN } = useFormatTIN()

    const { loadingState, payerListLoadingState, formList, selectedForm, taxYearList, selectedTaxYear, payersList, selectedPayer, rejected1099FormsGrid, selectedRejected1099Forms, paginationState, deleteRejectedFormModal, clickedFormDetails, gridDataLoadingState, payerDropdownPagination } = useSelector((state) => state[componentKey]);
    const [paginatedPayerList, setPaginatedPayerList] = useState([]);

    useEffect(() => {
        setPaginatedPayerList(payersList)
    }, [payersList])
    useEffect(() => {
        const urlFormId = queryParams.get(QUERY_PARAMS.FORM_ID);

        dispatch(getFormsList({ formId: urlFormId }));
    }, []);

    useEffect(() => {
        const urlTaxYear = queryParams.get(QUERY_PARAMS.TAX_YEAR);
        const urlPayerId = queryParams.get(QUERY_PARAMS.PAYER_ID);

        if (selectedForm?.value) {
            dispatch(getPayersBySelectedForm({ formId: selectedForm?.value, payerId: urlPayerId, taxYear: urlTaxYear, paginationState }));
            dispatch(getTaxYears({ formId: selectedForm?.value, taxYear: urlTaxYear }))
        }
    }, [selectedForm])

    const MANAGE_1099_FORMS_COLUMN = [
        {
            field: "Date",
            header: (
                <Label weight={LABEL_WEIGHT[700]} customStyles={{ ...commonStyles.text, ...commonStyles.date }}>
                    Date
                </Label>
            ),
            renderLogic: (row, idx) => (<span style={{ ...commonStyles.text, ...commonStyles.date }}>{row?.Date || "-"}</span>),
        },
        {
            field: "TIN",
            header: <Label weight={LABEL_WEIGHT[700]}>TIN</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{formatTIN(row.TINType, row.TIN) || "-"}</span>,
        },
        {
            field: "Name",
            header: <Label weight={LABEL_WEIGHT[700]}>Name</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{row?.Name || "-"}</span>,
        },
        {
            field: "Amount",
            header: <Label weight={LABEL_WEIGHT[700]}>Amount ($)</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{row?.Amount || "-"}</span>,
        },
        {
            field: "RecipientEmail",
            header: <Label weight={LABEL_WEIGHT[700]}>Recipient Email</Label>,
            renderLogic: (row, idx) => <span style={commonStyles.text}>{row?.RecipientEmail || "-"}</span>,
        },
        {
            field: "Status",
            header: (
                <Label weight={LABEL_WEIGHT[700]}>Status</Label>
            ),
            renderLogic: (row, idx) => <span style={commonStyles.text}>{row?.Status || "-"}</span>,
        },
        {
            field: "Remarks",
            header: <Label weight={LABEL_WEIGHT[700]}>Remarks</Label>,
            renderLogic: (row, idx) => (
                <span style={commonStyles.text}>{row.Remarks || "-"}</span>
            ),
        },
        {
            field: "Action",
            header: (
                <Label Label weight={LABEL_WEIGHT[700]}>
                    Action
                </Label>
            ),
            renderLogic: (row, idx) => (
                <div style={commonStyles.actionButtons}>
                    <Button title={'View PDF'} style={commonStyles.buttonBackgroundWIcon} onClickCb={() => dispatch(viewRejectedFormPDF({
                        formId: row?.FormId,
                        payerId: selectedPayer?.value,
                        formTypeId: selectedForm?.Id,
                    }))}><Icons familyName={'vec'} iconName={VEC_ICON_NAME.VIEW_ICON} /></Button>

                    <Button title={'Edit'} style={commonStyles.buttonBackgroundWIcon}
                        onClickCb={() => {
                            const queryObj = {
                                FormName: selectedForm?.FormId,
                                Year: row?.TaxYear,
                                FormRecordId: row?.FormId,
                                metaData: JSON.stringify({
                                    [EDIT_FORM_ORIGIN]: FORM_SECTION_ROUTES.REVIEW_REJECTED_FORMS,
                                })

                            }
                            const queryParamsStr = General.convertObjToQueryString(queryObj)

                            navigate(`/forms/createnew?${queryParamsStr}`)
                        }}
                    >
                        <Icons familyName={'vec'} iconName={VEC_ICON_NAME.EDIT_ICON} />
                    </Button>

                    <Button title={'Delete'} style={commonStyles.buttonBackgroundWIcon} onClickCb={() => {
                        dispatch(setClickedFormDetails(row));
                        dispatch(setDeleteRejectedFormModal(true))
                    }}><Icons familyName={'vec'} iconName={VEC_ICON_NAME.DELETE_ICON} /></Button>

                </div>
            ),
        },
    ];

    return (
        <Loadable currentState={loadingState.state} loadingStates={[REVIEW_REJECTED_LOADING_STATES.REVIEW_REJECTED_PAGE_LOADING]} messageMap={REVIEW_REJECTED_STATES_MESSAGE_MAP} preserveChildMount={true}>
            <div style={commonStyles.dropdownContainer}>
                <div style={commonStyles.selectDropdown}>
                    <div>
                        <Loadable
                            currentState={loadingState.state}
                            loadingStates={[REVIEW_REJECTED_LOADING_STATES.FORMS_LIST_LOADING]}
                            messageMap={REVIEW_REJECTED_STATES_MESSAGE_MAP}
                            isNewLoadable={true}
                        >
                            <SelectDropdown
                                label="Form *"
                                name="Form"
                                placeHolder="Please select a Form"
                                options={formList}
                                value={selectedForm}
                                onSelectCb={(name, selectedOption) => {
                                    dispatch(setSelectedForm(selectedOption));

                                    if (selectedOption?.value) {
                                        queryParams.set(QUERY_PARAMS.FORM_ID, selectedOption?.value)
                                    } else {
                                        queryParams.delete(QUERY_PARAMS.FORM_ID)
                                    }
                                    setQueryParams(queryParams);
                                }}
                            />
                        </Loadable>
                    </div>
                    <div>
                        <Loadable
                            currentState={loadingState.state}
                            loadingStates={[REVIEW_REJECTED_LOADING_STATES.TAXYEARS_LIST_LOADING]}
                            messageMap={REVIEW_REJECTED_STATES_MESSAGE_MAP}
                            isNewLoadable={true}
                        >
                            <SelectDropdown
                                label="Tax Year *"
                                name="TaxYear"
                                placeHolder="Please select a tax year"
                                options={taxYearList}
                                value={selectedTaxYear}
                                onSelectCb={(name, selectedOption) => {
                                    dispatch(setSelectedTaxYear(selectedOption));

                                    if (selectedOption?.value) {
                                        queryParams.set(QUERY_PARAMS.TAX_YEAR, selectedOption?.value)
                                    } else {
                                        queryParams.delete(QUERY_PARAMS.TAX_YEAR)
                                    }
                                    setQueryParams(queryParams);
                                }}
                            />
                        </Loadable>
                    </div>
                    <div>
                        <Loadable
                            currentState={payerListLoadingState.state}
                            loadingStates={[REVIEW_REJECTED_LOADING_STATES.PAYERS_LIST_LOADING]}
                            messageMap={REVIEW_REJECTED_STATES_MESSAGE_MAP}
                            isNewLoadable={true}
                        >
                        <SelectDropdown
                                label="Payer *"
                                name="Payer"
                                placeHolder="Please select a Payer"
                                options={paginatedPayerList.slice(0, payerDropdownPagination.PageSize * (payerDropdownPagination.PageNumber))}
                                onDropdownTouchedToBottomCb={() => {
                                    if(payerDropdownPagination.PageSize * (payerDropdownPagination.PageNumber) < paginatedPayerList?.length){   
                                        dispatch(setPayerDropdownPagination({ PageNumber: payerDropdownPagination.PageNumber + 1 }))
                                    }
                                }}
                                value={selectedPayer}
                                onSelectCb={(name, selectedOption) => {
                                    dispatch(setSelectedPayer(selectedOption));

                                    if (selectedOption?.value) {
                                        queryParams.set(QUERY_PARAMS.PAYER_ID, selectedOption?.value)
                                    } else {
                                        queryParams.delete(QUERY_PARAMS.PAYER_ID)
                                    }
                                    setQueryParams(queryParams);
                                }}
                        />
                        </Loadable>
                    </div>

                    <Button
                        type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER}
                        onClickCb={() => {
                            if (selectedForm?.label && selectedPayer?.value && selectedTaxYear?.value) {
                                dispatch(getRejectedFormsGridData({
                                    formId: selectedForm?.value,
                                    payerId: selectedPayer?.value,
                                    taxYear: selectedTaxYear?.value,
                                    PageNumber: paginationState?.PageNumber,
                                    PageSize: paginationState?.PageSize,
                                }))
                            } else {
                                dispatch(addNotifications({ heading: "Error", message: "Please select form, payer and tax year" }))
                            }
                        }}>
                        Search
                    </Button>

                    {rejected1099FormsGrid.length ? <Loadable currentState={loadingState.state} loadingStates={[REVIEW_REJECTED_LOADING_STATES.RESUBMIT_FORMS_LOADING]} messageMap={REVIEW_REJECTED_STATES_MESSAGE_MAP} isNewLoadable={true}
                        ><Button
                        style={{ ...commonStyles.button, ...commonStyles.resubmitBtn }}
                        onClickCb={() => {
                            if (selectedRejected1099Forms.length) {
                                dispatch(resubmitRejectedForm({
                                    formIds: selectedRejected1099Forms.map(f => f.FormId).toString(),
                                    payerId: selectedPayer?.value,
                                    formName: selectedForm?.FormLabel,
                                    payerName: selectedPayer?.LastName,
                                    taxyear: selectedTaxYear?.value,
                                    paginationState,
                                    formId: selectedForm?.value
                                }))
                            } else {
                                dispatch(addNotifications({ heading: "Error", message: "Please select a form" }))
                            }
                        }}
                    >Edit to Resubmit</Button></Loadable> : null}
                </div>
            </div>
            <Loadable
                currentState={loadingState.state}
                loadingStates={[COMMON_LOADING_STATES.GRID_LOADING]}
                messageMap={COMMON_LOADING_STATES_MESSAGE_MAP}
                isNewLoadable={true}
            >
                <RichGrid
                    selectable={true}
                    data={rejected1099FormsGrid}
                    columns={MANAGE_1099_FORMS_COLUMN}
                    extractRowKey={(row) => row.FormId}
                    selectedRows={selectedRejected1099Forms}
                    onSelectionChangeCallBack={(selectedData) => dispatch(setSelectedRejected1099Forms(selectedData))}
                    paginationProps={{
                        skip: paginationState?.Skip,
                        take: paginationState?.PageSize,
                        takeOptions: ROW_SELECTION_OPTIONS,
                        total: paginationState?.total,
                        onChangeTakeCb: (newTake) => {
                            dispatch(setPaginationState({ ...paginationState, PageSize: newTake, PageNumber: 1, Skip: 0 }));
                        },
                        onChange: (take, skip) => {
                            dispatch(setPaginationState({ ...paginationState, PageSize: take, Skip: skip, PageNumber: Math.ceil((take + skip) / take) }));
                        },
                    }}
                />
            </Loadable>

            {deleteRejectedFormModal && <ConfirmationPopup
                title={"Are you sure?"}
                bodyText={`Are you sure you want to delete this form?`}
                iconName={VEC_ICON_NAME.WARNING_ICON}
                isOpen={deleteRejectedFormModal}
                confirmationButtonProps={{
                    onConfirmationCb: () => {
                        dispatch(deleteRejectedForm({
                            formSubmissionId: clickedFormDetails?.FormId,
                            formId: selectedForm?.value,
                            payerId: selectedPayer?.value,
                            taxYear: selectedTaxYear?.value,
                            paginationState
                        }))
                    },
                    confirmationButtonText: "Delete",
                    confirmationButtonStyles: {},
                    confirmationButtonType: BUTTON_TYPE.PRIMARY,
                }}
                cancelButtonProps={{
                    onCancelCb: () => dispatch(setDeleteRejectedFormModal(false)),
                    cancelButtonText: "Cancel",
                    cancelButtonStyles: {},
                    cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
                }}
                showClose={false}
                loadingState={loadingState}
                loaderLoadingStates={[REVIEW_REJECTED_LOADING_STATES.DELETE_MODAL_LOADING]}
                loaderMessageMap={REVIEW_REJECTED_STATES_MESSAGE_MAP}
                preserveLoaderChildMount={false}
            />}

        </Loadable>
    );
}

export default Form1099;
